import Layout from "../../../Components/Layout";
import BasicInfo from "../../../Components/EventMgt/CreateEvent/BasicInfo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
const BasicInfoPage = () => {
  const params = useParams();
  const { eventId } = params;
  const location = useLocation();
  const navigate = useNavigate();

  console.log({ eventId });

  useEffect(() => {
    if (
      location.pathname !== "/myEvents/create/basic_info" &&
      (eventId === "undefined" ||
        eventId === undefined ||
        eventId === null ||
        !eventId)
    ) {
      navigate("/");
      return;
    }
  }, [location || eventId]);

  return (
    <Layout
      BackAction="/organizer/MyEvents"
      Heading="Basic Info"
      TitleClassName="event-create-title"
      HeadClassName="event-page-head event-create-head"
      CreateHead
      activeMenuId="create-event"
      ExtraclassName="event-create-panel"
    >
      <BasicInfo />
    </Layout>
  );
};
export default BasicInfoPage;
